import styled from 'styled-components';

import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import { grey1, grey5, grey9 } from 'approot/shared/styles/colours.style';

export const InteractiveResponseAudioStatic = styled(SecondaryButtonIcon).attrs(
  {
    as: 'div',
    $borderRadius: 40,
  }
)`
  &:hover {
    cursor: default;
    background-color: ${grey1};
    border-color: ${grey5};
    color: ${grey9};
  }

  &:active {
    box-shadow: none;
  }
`;
